"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyLayoutPage = void 0;
var _components = require("../../components");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * This component wraps the provided content within a Page component,
 * with no additional features tailored for specific layout elements.
 * Please remember to add <main> landmark with <SkipTo> component where appropriate.
 *
 * @param props - Props for the {@link EmptyLayoutPageProps} component.
 * @returns A JSX element representing the EmptyLayout.
 *
 * @remarks
 * This component is designed to provide a basic layout with no additional features,
 * suitable for pages where no specific layout elements are required.
 *
 * @example
 * ```tsx
 * <EmptyLayout>
 *   <PageContent />
 * </EmptyLayout>
 * ```
 */
const EmptyLayoutPage = ({
  page,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Page, {
  ...page,
  children: children
});
exports.EmptyLayoutPage = EmptyLayoutPage;
